module.exports = __webpack_public_path__ + "static/media/stores.3118d951.png";